import Qualifier from "../../../model/formconfiguration/Qualifier";
import { formatBooleanValue } from "../../..";

const QualifierListMapper = (json: any[] = []) => {
  return json.map((item: any) => {
    let qualifier = Qualifier(item);
    qualifier.valid = formatBooleanValue(item.valid);
    return qualifier;
  });
};

export default QualifierListMapper;
